import axios from '../api/axiosInstance';
import { API_ENDPOINTS } from '../api/apiEndpoints';

export const CitationData = {
  extracted_text: '',
  metadata: {
    filename: '',
  },
}

export const fetchCitations = async (
  chatId,
  userId,
  pairId
) => {
  try {
    const response = await axios.get(API_ENDPOINTS.citations(chatId, userId, pairId));
    return response.data.data || response.data || [];
  } catch (error) {
    console.error('Failed to fetch citations:', error);
    throw error;
  }
}; 